import { Flex, OnboardingLayout } from "@wayflyer/flyui";
import { useIntl } from "react-intl";

import { UploadDocumentType } from "../../../types";
import { SusaDocumentUpload, useDocumentNavigationActions, MESSAGES } from "../components";

export const SusaDocumentUploadPage = () => {
  const intl = useIntl();

  const { primaryAction, secondaryAction } = useDocumentNavigationActions({ forType: UploadDocumentType.SUSA });

  return (
    <OnboardingLayout
      variant="wide"
      title={intl.formatMessage(MESSAGES.susaTitle)}
      actions={{ primary: primaryAction, secondary: secondaryAction }}
    >
      <Flex maxWidth="550px">
        <SusaDocumentUpload />
      </Flex>
    </OnboardingLayout>
  );
};
